import { createBrowserRouter } from 'react-router';
import { RequireAuth, RequireStaff } from './features/auth/guards.tsx';
import { LoginPage } from './features/auth/LoginPage.tsx';
import { OrdersPage } from './features/orders/OrdersPage.tsx';
import { NotFoundPage } from './features/shell/NotFoundPage.tsx';
import { Shell } from './features/shell/Shell.tsx';
import {
  AccountPage,
  ClientDetailPage,
  ClientsPage,
  DiagnosisWizardPage,
  NewOrderPage,
  NotificationsPage,
  OrderDetailPage,
  TeamPage,
} from './lazy-pages.tsx';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: (
      <RequireAuth>
        <Shell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <OrdersPage /> },
      {
        path: 'new',
        element: (
          <RequireStaff>
            <NewOrderPage />
          </RequireStaff>
        ),
      },
      { path: 'orders/:id', element: <OrderDetailPage /> },
      { path: 'orders/:id/diagnostico', element: <DiagnosisWizardPage /> },
      {
        path: 'clients',
        element: (
          <RequireStaff>
            <ClientsPage />
          </RequireStaff>
        ),
      },
      {
        path: 'clients/:id',
        element: (
          <RequireStaff>
            <ClientDetailPage />
          </RequireStaff>
        ),
      },
      {
        path: 'team',
        element: (
          <RequireStaff>
            <TeamPage />
          </RequireStaff>
        ),
      },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
